import React, { Component } from "react";
// import { Container, Row, Col, InputGroup } from "reactstrap";
import HotelDropDown from "./HotelDropDown";
import ReportsDropDown from "./ReportsDropDown";
import ConnectorDropDown from "./ConnectorDropdown";
import FileTraceFilterDatePickers from "./FileTraceFilterDatePickers";
// import CustomDatepicker from "../../Common/CustomDatepicker/CustomDatepicker";
import FiletraceRangePicker from "./FiletraceRangePicker";

import { CreateDatePicker } from "../../Common/interfaces";

import {
  Row,
  Col,
  Collapse,
  Select,
  Button,
  Tooltip,
  DatePicker,
  Form,
} from "antd";
import "antd/dist/antd.css";
import "../FileTraceTableSection/FileTraceTableSection.css";
import { DownOutlined } from "@ant-design/icons";
import FilterDropdown from "./FilterDropDown";
import moment from "moment";

import { commonValuesTypes, datePickerProps } from "../../../commonConfig.json";

const { Panel } = Collapse;
const { Option } = Select;

class FileTraceFilterSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateSearchData: props.updateSearchData,
      reportData: [],
      reportIndexName: "",
      //name in customList objects are actually index value type
      customList: [
        {
          name: "Hotels",
          component: null,
          // param : "eventData.hotel",
          param: "Hotels",
          searchIn: "mydocs",
        },
        {
          //     name : "File Name",
          //     component : null,
          //     param : "eventData.fileName",
          //     searchIn : "connector",
          // },{
          name: "Submission Method",
          component: null,
          param: "eventSource",
          searchIn: "connector",
        },
        {
          name: "File Uploaded Date",
          component: null,
          param: "eventTime",
          searchIn: "connector",
        },
      ],
      dateConfig: [
        {
          name: "File Uploaded Date",
          max: 1,
        },
        {
          name: "Date",
          max: 0,
        },
      ],
      // tempVals: {

      // },
      disableButtons: true,
      slectedVals: {},
      changeHMGEvent: false,
      range: [],
    };

    this.clearFilter = this.clearFilter.bind(this);
    this.processFilter = this.processFilter.bind(this);
    this.createDropDown = this.createDropDown.bind(this);
    this.processChange = this.processChange.bind(this);
  }

  formRef = React.createRef();
  filterSelected = 0;
  searchClicked = false;
  clearFilter() {
    this.formRef.current.resetFields();
    this.filterSelected = 0;
    this.setState(
      { disableButtons: true, range: [] },
      // { tempVals: {}, disableButtons: true },
      () => {
        this.toReset = [];
        if (this.searchClicked) {
          this.props.clearSearch();
        } else {
          this.props.resetHotel();
          this.props.resetBDate();
        }
        this.searchClicked = false;
      }
    );
  }

  toReset = [];
  clearSpecificFilter() {
    console.log("Clearing specific :", this.toReset);
    this.formRef.current.resetFields(this.toReset);
    this.toReset = [];
  }

  componentWillReceiveProps(newProp) {
    // alert("FI : "+JSON.stringify(newProp.sidebarClick));

    if (newProp.sidebarClick) {
      this.props.setSidebarClick(false);
      // this.formRef.current.resetFields();
      this.clearFilter();
    }

    let changeHMG = false;
    if (this.state.changeHMGEvent !== newProp.changeHMGEvent) {
      changeHMG = true;
    }
    this.setState(
      {
        reportData: newProp.reportData,
        changeHMGEvent: newProp.changeHMGEvent,
      },
      () => {
        if (changeHMG) {
          this.searchClicked = false;
          this.clearFilter();
        }
      }
    );
  }

  processFilter(
    searchName,
    value,
    searchIn,
    valuesType,
    selectedOption,
    additionalData
  ) {
    // this.state.tempVals[searchName] = (value != null) ? selectedOption : value;

    if (value !== null) {
      this.filterSelected++;
    } else {
      if (this.filterSelected > 0) {
        this.filterSelected--;
      }
    }

    if (this.filterSelected > 0) {
      this.state.disableButtons = false;
    } else {
      this.state.disableButtons = true;
    }

    this.toReset = [];
    if (valuesType === commonValuesTypes.HOTELS) {
      this.toReset.push(commonValuesTypes.REPORT);
      this.toReset.push(commonValuesTypes.REPORT_CATEGORY);
      this.toReset.push(commonValuesTypes.SUBMISSION_SCHEDULE);
    }

    if (this.filterSelected === 0 && this.searchClicked) {
      this.props.clearSearch();
    } else {
      this.clearSpecificFilter();
      this.props.updateSearchData(
        searchName,
        value,
        searchIn,
        valuesType,
        additionalData
      );
    }
  }

  createDropDown(index) {
    let optionList = [];

    //sorter
    if (index.values.length > 0 && index.name.toLowerCase() != "month") {
      let indexVal = index.values[0];
      if (typeof indexVal === "object" && indexVal !== null) {
        if (indexVal.description != undefined) {
          index.values.sort(function (a, b) {
            return a.description.toUpperCase() > b.description.toUpperCase()
              ? 1
              : -1;
          });
        } else if (indexVal.label != undefined) {
          index.values.sort(function (a, b) {
            return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
          });
        } else {
          index.values.sort(function (a, b) {
            return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
          });
        }
      } else {
        index.values.sort(function (a, b) {
          return a.toUpperCase() > b.toUpperCase() ? 1 : -1;
        });
      }
    }

    index.values.forEach((indexVal) => {
      if (typeof indexVal === "object" && indexVal !== null) {
        if (indexVal.description != undefined) {
          optionList.push(
            <Option key={indexVal.value} value={indexVal.value}>
              {indexVal.description}
            </Option>
          );
        } else if (indexVal.label != undefined) {
          optionList.push(
            <Option key={indexVal.value} value={indexVal.value}>
              {indexVal.label}
            </Option>
          );
        } else {
          optionList.push(
            <Option key={indexVal.value} value={indexVal.value}>
              {indexVal.value}
            </Option>
          );
        }
      } else {
        optionList.push(
          <Option key={indexVal} value={indexVal}>
            {indexVal}
          </Option>
        );
      }
    });

    //replace space on index name
    let componentName =
      index.valuesType.toLowerCase() != "custom"
        ? index.valuesType
        : index.valuesType + "_" + index.name.replace(" ", "");

    return (
      <Row type="flex" justify="center">
        <Col span={6}>
          <span style={{ paddingRight: "10px" }}>{index.name}</span>
        </Col>
        <Col span={18}>
          <Form.Item name={componentName}>
            <Select
              // value={resetVal}
              disabled={
                index.valuesType != undefined &&
                index.valuesType === commonValuesTypes.SUBMISSION_SCHEDULE &&
                !this.props.hotelSelected
              }
              name={componentName}
              allowClear
              labelInValue
              showSearch
              style={{ width: "100%" }}
              placeholder={
                index.placeholder != undefined && index.placeholder != null
                  ? index.placeholder
                  : index.name
              }
              optionFilterProp="children"
              onChange={(selectedOption) => {
                let val = null;
                if (selectedOption !== undefined) {
                  val = selectedOption.key;
                }

                if (val !== null) {
                  this.filterSelected++;
                } else {
                  if (this.filterSelected > 0) {
                    this.filterSelected--;
                  }
                }

                if (this.filterSelected > 0) {
                  this.state.disableButtons = false;
                } else {
                  this.state.disableButtons = true;
                }
                this.toReset = [];
                if (
                  val != null &&
                  index.valuesType === commonValuesTypes.SUBMISSION_SCHEDULE
                ) {
                  this.toReset.push(commonValuesTypes.REPORT);
                  this.toReset.push(commonValuesTypes.REPORT_CATEGORY);
                }

                // if(val != null && index.valuesType === "Report Category"){
                //     this.toReset.push("Report");
                // }

                if (this.filterSelected === 0 && this.searchClicked) {
                  this.props.clearSearch();
                } else {
                  this.clearSpecificFilter();
                  this.props.updateSearchData(
                    index.searchName,
                    val,
                    index.searchIn,
                    index.valuesType,
                    ""
                  );
                }
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {optionList}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    );
  }

  createDatePicker(index) {
    let dateConfig = this.state.dateConfig;
    let maxDate = null;
    let minDate = null;

    for (let x = 0; x < dateConfig.length; x++) {
      let conf = dateConfig[x];
      if (conf.name === index.valuesType) {
        if (conf.max != undefined) {
          maxDate = new Date();
          maxDate.setDate(maxDate.getDate() + conf.max);
        }
        if (conf.min != undefined) {
          minDate = new Date();
          minDate.setDate(minDate.getDate() + conf.min);
        }

        break;
      }
    }

    return (
      <Row type="flex" justify="center">
        <Col span={6}>
          <span style={{ paddingRight: "10px" }}>
            {index.valuesType === "Date" ? "Business Date" : index.name}
          </span>
        </Col>
        <Col span={18}>
          <Form.Item name={index.name}>
            <DatePicker
              id={index.searchName}
              onChange={(value, formattedValue) => {
                this.setState({
                  value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
                  formattedValue: formattedValue, // Formatted String, ex: "11/19/2016"
                });
                // alert(value+" : "+formattedValue)
                if (formattedValue === "") {
                  formattedValue = null;
                }

                // this.state.tempVals[index.searchName] = formattedValue;
                if (formattedValue !== null) {
                  this.filterSelected++;
                } else {
                  if (this.filterSelected > 0) {
                    this.filterSelected--;
                  }
                }

                if (this.filterSelected > 0) {
                  this.state.disableButtons = false;
                } else {
                  this.state.disableButtons = true;
                }
                // alert(this.filterSelected+" : "+JSON.stringify(this.state.tempVals)+" : "+this.state.disableButtons);

                if (this.filterSelected === 0 && this.searchClicked) {
                  this.props.clearSearch();
                } else {
                  this.props.updateSearchData(
                    index.searchName,
                    formattedValue,
                    index.searchIn,
                    index.valuesType,
                    ""
                  );
                }
              }}
              // disabledDate={ d => !d || d.isAfter(this.state.maxDate) }
              disabledDate={(d) =>
                !d || (maxDate != null && d.isAfter(maxDate))
              }
              style={{ width: "100%" }}
              placeholder="MM-DD-YYYY"
              format={"MM-DD-YYYY"}
              showToday={false}
            />
          </Form.Item>
        </Col>
      </Row>
    );
  }

  processChange(selectedOption, index) {
    let val = null;
    if (selectedOption !== undefined) {
      val = selectedOption.key;
    }

    if (val !== null) {
      this.filterSelected++;
    } else {
      if (this.filterSelected > 0) {
        this.filterSelected--;
      }
    }

    if (this.filterSelected > 0) {
      this.state.disableButtons = false;
    } else {
      this.state.disableButtons = true;
    }

    let slectedVals = this.state.slectedVals;
    slectedVals[index.valuesType] = val;
    if (index.valuesType === "c1") {
      slectedVals["c2"] = null;
    }

    this.setState({ slectedVals: slectedVals }, () => {
      if (this.filterSelected === 0 && this.searchClicked) {
        this.props.clearSearch();
      } else {
        this.props.updateSearchData(
          index.searchName,
          val,
          index.searchIn,
          index.valuesType,
          ""
        );
      }
    });
  }

  render() {
    let customList = this.state.customList;
    let allowedConnectors = this.props.allowedConnectors;
    let searchIndexes = this.props.searchIndexes;
    let indexSortOrder = this.props.indexSortOrder;

    let col1 = [];
    let col2 = [];
    let col3 = [];

    let sortedIndexes = [];
    //push normal
    for (let x = 0; x < searchIndexes.length; x++) {
      let index = searchIndexes[x];
      let searchObj = "";
      let configFound = false;
      for (let y = 0; y < customList.length; y++) {
        let customObj = customList[y];

        if (customObj.name === index.valuesType) {
          configFound = true;
          if (commonValuesTypes.HOTELS === index.valuesType) {
            searchObj = (
              <HotelDropDown
                user={this.props.user}
                updateSearchData={this.props.updateSearchData}
                // hotelVal={this.state.tempVals[index.name]}
                valuesType={index.valuesType}
                processFilter={this.processFilter}
                hotelIndexName={index.name}
                additionalData={this.state.reportIndexName}
                searchIn={"mydocs"}
                projectDetails={this.props.projectDetails}
              />
            );
          } else if (customObj.component !== null) {
            searchObj = customObj.component;
          } else if (customObj.component === null) {
            index.searchName = customObj.param;
            index.searchIn = customObj.searchIn;
          }
          break;
        }
      }

      if (!configFound) {
        index.searchName = index.name;
        index.searchIn = "mydocs";
        if (commonValuesTypes.REPORT === index.valuesType) {
          this.state.reportIndexName = index.name;
          index.values = this.props.reportData;
        } else if (commonValuesTypes.SUBMISSION_SCHEDULE === index.valuesType) {
          index.values = this.props.validSubmissionSchedules;
        } else if (commonValuesTypes.REPORT_CATEGORY === index.valuesType) {
          index.values = this.props.validReportCategories;
        }
      }
      //alert(index.name+" : "+searchObj)
      if (searchObj === "") {
        if (index.type === "Text") {
          // searchObj = <FilterDropdown index={index} updateSearchData={this.props.updateSearchData}/>
          searchObj = this.createDropDown(index);
        } else if (index.type === "Date") {
          if (index.valuesType === "Date") {
            const modeExtensions = [
              "business_date",
              "last_seven_days",
              "last_thirty_days",
              "this_month",
              "last_month",
              "last_two_months",
              "custom_range",
            ];

            let disabeldDate = moment().subtract(1, "days").format("MM-DD-YYYY");
            searchObj = (
              <Row type="flex" justify="center">
                <Col span={6}>
                  <span style={{ paddingRight: "10px" }}>Business Date</span>
                </Col>
                <Col span={18}>
                  <Form.Item name={index.name}>
                    <FiletraceRangePicker
                      key={"comp_search_" + index.name}
                      indexOrder={index.order}
                      labelPosition={datePickerProps.labelPosition.HORIZONTAL}
                      labelName="Business Date"
                      indexName={index.name}
                      indexType={index.type.toLowerCase()}
                      indexValType={index.valuesType}
                      indexCategory="independentIndexes"
                      selectedRange={this.state.range}
                      disabledRange={{
                        type: "min_max",
                        val: [disabeldDate],
                      }}
                      mode={datePickerProps.mode.RANGE}
                      modeExtensions={modeExtensions}
                      pickerType="date" // conditions might need later
                      format={
                        index.format === "MM-dd-yyyy"
                          ? "MM-DD-YYYY"
                          : index.format
                      }
                      apply={
                        modeExtensions.length !== 0 &&
                        !(
                          modeExtensions.length < 2 &&
                          modeExtensions.includes(
                            datePickerProps.modeExtension.CUSTOM_RANGE
                          )
                        )
                          ? datePickerProps.apply.ONAPPLY
                          : datePickerProps.apply.ONCHANGE
                      } //modeExtensions contains customrange - apply
                      callback={(responseData) => {
                        let { selectedOption, key, valuesType, actualApply } =
                          responseData;
                        this.setState({
                          range: selectedOption, // Formatted String, ex: "11/19/2016"
                        });

                        // this.state.tempVals[index.searchName] = formattedValue;
                        if (actualApply) {
                          this.filterSelected++;
                        } else {
                          if (this.filterSelected > 0) {
                            this.filterSelected--;
                          }
                        }

                        if (this.filterSelected > 0) {
                          this.state.disableButtons = false;
                        } else {
                          this.state.disableButtons = true;
                        }

                        if (this.filterSelected === 0 && this.searchClicked) {
                          this.props.clearSearch();
                        } else {
                          this.props.updateSearchData(
                            responseData.key,
                            responseData.selectedOption.length === 0
                              ? null
                              : responseData.selectedOption,
                            index.searchIn,
                            responseData.valuesType,
                            "range"
                          );
                        }
                      }}
                      labelPosition={datePickerProps.labelPosition.HORIZONTAL}
                      disabled={false}
                      placeholder={["MM-DD-YYYY"]}
                      customWrapper={true}
                    />
                  </Form.Item>
                </Col>
              </Row>
            );
          } else {
            searchObj = this.createDatePicker(index);
          }
        }
      }

      let searchComp = <>{searchObj}</>;

      let idx = {
        order: 999999,
        comp: searchComp,
        name: index.name,
      };

      for (let y = 0; y < indexSortOrder.length; y++) {
        if (indexSortOrder[y]["indexId"] === index["_id"]) {
          idx["order"] = indexSortOrder[y]["order"];
          break;
        }
      }

      sortedIndexes.push(idx);
    }

    sortedIndexes.sort((a, b) => {
      // alert(a.name+" : "+a.order+" | "+b.name+" : "+b.order)
      return a.order > b.order ? 1 : -1;
    });

    //generate search indexes
    for (let x = 0; x < sortedIndexes.length; x++) {
      // alert(sortedIndexes[x]["order"] + " : "+ sortedIndexes[x]["name"])
      if ((x + 1) % 2 !== 0) {
        col1.push(sortedIndexes[x]["comp"]);
      } else {
        col2.push(sortedIndexes[x]["comp"]);
      }
    }
    //push connector
    let connectorIndex = {
      name: "Submission Method",
      searchName: "eventSource",
      placeholder: "Submission Method",
      values: allowedConnectors,
      type: "Text",
      searchIn: "connector",
      valuesType: "Submission Method",
    };
    let connectorDropDown = this.createDropDown(connectorIndex);
    let connectorComponent = <>{connectorDropDown}</>;

    if (searchIndexes.length === 0) {
      col1.push(connectorComponent);
    } else {
      if (searchIndexes.length % 2 !== 0) {
        col2.push(connectorComponent);
      } else {
        col1.push(connectorComponent);
      }
    }

    let buttonComponent = (
      <Form.Item key="filter_buttons">
        <Row gutter={[0, 48]} type="flex" justify="center" align="middle">
          {/* <Row gutter={[0, 0]} type="flex" justify="center"> */}
          <Col
            xs={{ span: 11, offset: 2 }}
            sm={{ span: 11, offset: 2 }}
            md={{ span: 11, offset: 2 }}
            lg={{ span: 11, offset: 2 }}
            xl={{ span: 11, offset: 2 }}
            style={{ paddingBottom: "0px" }}
          >
            <Tooltip title="Cancel">
              <Button
                disabled={this.state.disableButtons}
                type="link"
                onClick={() => {
                  this.clearFilter();
                }}
              >
                Cancel
              </Button>
            </Tooltip>
          </Col>
          <Col
            xs={11}
            sm={11}
            md={11}
            lg={11}
            xl={11}
            style={{ paddingBottom: "0px" }}
          >
            <Tooltip title="Search">
              <Button
                type="primary"
                disabled={this.state.disableButtons}
                onClick={() => {
                  this.searchClicked = true;
                  this.props.searchReportData();
                }}
              >
                SEARCH
              </Button>
            </Tooltip>
          </Col>
        </Row>
      </Form.Item>
    );
    let buttonSectionEmpty = (
      <Row gutter={[0, 48]} type="flex" justify="center" align="middle">
        <Col
          xs={{ span: 11, offset: 2 }}
          sm={{ span: 11, offset: 2 }}
          md={{ span: 11, offset: 2 }}
          lg={{ span: 11, offset: 2 }}
          xl={{ span: 11, offset: 2 }}
          style={{ paddingBottom: "0px" }}
        >
          &nbsp;
        </Col>
        <Col
          xs={11}
          sm={11}
          md={11}
          lg={11}
          xl={11}
          style={{ paddingBottom: "0px" }}
        >
          &nbsp;
        </Col>
      </Row>
    );
    if (col1.length == 1) {
      col3.push(buttonComponent);
    } else {
      for (let index = 1; index < col1.length; index++) {
        if (col1.length % 2 !== 0) {
          let half = col1.length / 2;
          if (index == half.toFixed(0)) {
            col3.push(buttonComponent);
          } else {
            col3.push(buttonSectionEmpty);
          }
        } else {
          if (index == col1.length / 2) {
            col3.push(buttonComponent);
          } else {
            col3.push(buttonSectionEmpty);
          }
        }
      }
    }

    return (
      <Form ref={this.formRef} name="control-ref">
        <Row gutter={[40, 15]} type="flex" justify="center">
          <Col
            xs={24}
            sm={24}
            md={10}
            lg={10}
            xl={10}
            style={{ paddingBottom: "0px" }}
          >
            {col1}
          </Col>
          <Col
            xs={24}
            sm={24}
            md={10}
            lg={10}
            xl={10}
            style={{ paddingBottom: "0px" }}
          >
            {col2}
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={4}
            xl={4}
            style={{ paddingBottom: "0px" }}
          >
            {col3}
          </Col>
        </Row>
      </Form>
    );
  }
}

export default FileTraceFilterSection;
